<div class="info-header" [ngClass]="{ expanded: expanded }">
  <div class="info-header__left">
    <button class="info-header__left__back-button" (click)="goBack()">
      <span class="material-icons">keyboard_arrow_left</span>Back
    </button>
    <h2>Project History</h2>
  </div>
</div>
